import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="w-8 h-8 border-4 border-brand-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    const isAdmin = roles?.includes('admin') || roles?.includes('operador');
    return <Navigate to={isAdmin ? '/admin/login' : '/login'} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    if (user.role === 'cliente') return <Navigate to="/pedidos" replace />;
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
}
